// prettier-ignore

export const user = {
  mfaText: "Multi-Factor Authentication",
  mfaInstructions: "Use MFA to increase the security of your account. Signing in to MFA-protected accounts require you to enter a one-time verification code sent to either your email or a verified phone.",
  selectAllAgencyCodesLabel: "all-agency-codes"
};
